import React, { useState } from 'react';
import ModalProvider from './providers/ModalProvider';
import Results from './components/Results';
import Settings from './components/Settings';
import SettingsProvider from './providers/SettingsProvider';
import UrlSettingsProvider from './providers/UrlSettingsProvider';
import Molds from './components/Molds';
import styles from './App.module.scss';

const App = () => {
  const [ratio, setRatio] = useState(1);
  const [crustRatio, setCrustRatio] = useState(1);

  return (
    <UrlSettingsProvider>
      <SettingsProvider>
        <ModalProvider>
          <div className={styles.app}>
            <Molds setCrustRatio={setCrustRatio} setRatio={setRatio} />
            <Settings />
            <Results crustRatio={crustRatio} ratio={ratio} />
          </div>
        </ModalProvider>
      </SettingsProvider>
    </UrlSettingsProvider>
  );
};

export default App;
